import styled, { css } from 'styled-components';
import { darken } from 'polished';

const StyledInput = styled.input`
  border-radius: ${props => props.theme.borderRadius || 0};
  padding: ${props => (props.error || props.border ? '6px' : '8px')};
  background: ${props => props.theme.inputBackground || 'white'};
  color: ${props => props.theme.inputColor || 'unset'};
  height: ${props => props.height || '22px'};
  text-align: ${props => props.align || 'unset'};

  outline: 0;
  min-width: 0;
  font-size: ${props => props.fontSize || props.theme.customInputFontSize || '16px;'};
  width: ${props => props.width || '100%'};
  transition: width 100ms linear;
  ${({
    error, theme, border, rightSideInInput,
  }) => {
    if (rightSideInInput) {
      return css`
        border: 0;
        transition: all 250ms;
      `;
    }
    if (border) {
      return css`
        border: ${border};
        transition: all 250ms;
      `;
    } else if (error) {
      return css`
        border: 3px solid ${theme.danger};
        transition: all 250ms;
      `;
    }

    return css`
      border: thin solid ${theme.borderColor};
      transition: all 250ms;
    `;
  }}

  @media only screen and (max-width: 850px) {
    width: 100%;
  }

  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
    line-height: ${props => props.height || '22px'};
  }

  &:disabled {
    background: ${props => props.theme.disabledInputBackground || '#eee'};
    color: ${props =>
    (props.theme.disabledInputBackground
      ? darken(0.3, props.theme.disabledInputBackground)
      : '#aaa')};
  }

  :-webkit-autofill,
  :-webkit-autofill:hover,
  :-webkit-autofill:focus,
  :-webkit-autofill:active {
    -webkit-box-shadow: 0 0 0 30px ${props => props.theme.inputBackground || 'white'} inset !important;
  }
`;

export default StyledInput;
